import React from 'react';
import { Typography, Input } from 'antd';
import { StrategyPhase } from '../ProfitScenario/types';

const { Text } = Typography;

interface PhaseDescriptionProps {
    phase: StrategyPhase;
    updatePhaseInfo: (phaseId: string, updates: any) => void;
}

export const PhaseDescription: React.FC<PhaseDescriptionProps> = ({ phase, updatePhaseInfo }) => {
    return (
        <div style={{
            marginBottom: 20,
            background: '#f9f9f9',
            padding: '16px',
            borderRadius: 8,
            border: '1px solid #f0f0f0'
        }}>
            <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center' }}>
                <Text strong style={{ fontSize: 14 }}>🎯 阶段运营重点与打法说明</Text>
                <Text type="secondary" style={{ marginLeft: 8, fontSize: 12 }}>
                    (请详细描述本阶段的流量来源、转化策略及核心关注指标)
                </Text>
            </div>
            <Input.TextArea
                rows={3}
                placeholder="例如：1. 开启自动广告，积累关键词数据；2. 重点关注点击率(CTR)，优化主图和标题；3. 配合站外推广提升前期销量..."
                value={phase.strategyDescription}
                onChange={e => updatePhaseInfo(phase.id, { strategyDescription: e.target.value })}
                style={{ resize: 'vertical', borderRadius: 4 }}
            />
        </div>
    );
};
